import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    tiposDocumentos: []
  },
  actions: {
    getTipoDocumento ({commit}, tipoDocumentoId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/val_tipo_documentos/${tipoDocumentoId}`)
          .then((response) => {
            commit('setTipoDocumentoMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getTiposDocumentos ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_tipo_documentos')
          .then((response) => {
            commit('setTiposDocumentosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getTiposDocumentosActivos ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_tipo_documentos?activo=1')
          .then((response) => {
            commit('setTiposDocumentosActivosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addTipoDocumento ({ commit }, tipoDocumento) {
      return new Promise((resolve, reject) => {
        axios.post('/api/val_tipo_documentos', tipoDocumento)
          .then((response) => {
            commit('addTipoDocumentoMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteTipoDocumento ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/val_tipo_documentos/${id}`)
          .then((response) => {
            commit('deleteTipoDocumentoMutation', id)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateTipoDocumento ({ commit }, tipoDocumento) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/val_tipo_documentos/${tipoDocumento.id}`, tipoDocumento, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updateTipoDocumentoMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    emptyTiposDocumentos ({ commit }) {
      commit('emptyTiposDocumentosMutation')
    }
  },
  mutations: {
    setTipoDocumentoMutation (state, tipoDocumento) {
      state.tipoDocumento = tipoDocumento
    },
    setTiposDocumentosMutation (state, tipoDocumento) {
      state.tiposDocumentos = tipoDocumento
    },
    setTiposDocumentosActivosMutation (state, tipoDocumento) {
      state.TiposDocumentosActivos = tipoDocumento
    },
    addTipoDocumentoMutation (state, tipoDocumento) {
      state.tiposDocumentos.push(tipoDocumento)
    },
    updateTipoDocumentoMutation (state, tipoDocumento) {
      const idx = state.tiposDocumentos.findIndex((u) => u.id === tipoDocumento.id) // Buscamos o índice do elemento no array do state
      state.tiposDocumentos.splice(idx, 1, tipoDocumento)
    },
    deleteTipoDocumentoMutation (state, id) {
      const idx = state.tiposDocumentos.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.tiposDocumentos.splice(idx, 1)
    },
    emptyTiposDocumentosMutation (state) {
      // Vaciamos o store
      state.tiposDocumentos = []
    }
  },
  modules: {}
})